{
	"actions": {
		"cancel": "Annulla",
		"change_email": "Correggi l'indirizzo e reinvia",
		"change_role": "Cambia il ruolo",
		"deactivate": "Disattiva l'accesso",
		"open_menu": "Apri il menu delle azioni",
		"reactivate": "Riattiva l'accesso",
		"remove": "Rimuovi dall'organizzazione",
		"resend": "Reinvia l'invito",
		"resend_cooldown_one": "Reinvia tra {{count}} s",
		"resend_cooldown_other": "Reinvia tra {{count}} s",
		"revoke": "Revoca l'invito",
		"sending": "Invio…",
		"set_quota": "Modifica quota",
		"view_audit": "Vedi l'attività di questa persona"
	},
	"change_email": {
		"already_active": "Non è stato cambiato niente: questa persona ha già attivato il suo accesso, e da quel momento l'indirizzo è del suo account.",
		"description": "L'invito era stato inviato a {{email}}. Partirà verso il nuovo indirizzo e il link precedente smetterà di funzionare.",
		"new_email": "Nuovo indirizzo",
		"sent": "Invito rimandato a {{email}}.",
		"submit": "Correggi e reinvia",
		"title": "Correggere l'indirizzo dell'invito"
	},
	"change_role": {
		"confirm": "Cambia ruolo",
		"done": "Il ruolo di {{name}} ora è {{role}}.",
		"pending": "Modifica…",
		"role": "Ruolo",
		"title": "Cambiare il ruolo di {{name}}?"
	},
	"channel": {
		"pending": "La connessione in tempo reale però non si è chiusa, e il tentativo è in coda: finché non va a buon fine, questa persona continua a ricevere eventi.",
		"pending_within": "La connessione in tempo reale però non si è chiusa, e il tentativo è in coda: finché non va a buon fine, questa persona continua a ricevere eventi, al massimo per {{window}}."
	},
	"columns": {
		"actions": "Azioni",
		"email": "Email",
		"invitation": "Invito",
		"last_activity": "Ultima attività",
		"name": "Nome",
		"role": "Ruolo",
		"status": "Stato",
		"storage": "Spazio"
	},
	"deactivate": {
		"confirm": "Disattiva l'accesso",
		"description": "Non potrà più accedere e le sessioni aperte verranno chiuse. Puoi riattivare l'accesso quando vuoi.",
		"done": "Accesso disattivato.",
		"done_sessions_one": "Accesso disattivato, {{count}} sessione chiusa.",
		"done_sessions_other": "Accesso disattivato, {{count}} sessioni chiuse.",
		"pending": "Disattivazione…",
		"reason": "Motivo (facoltativo)",
		"reason_help": "Resta nel registro attività. {{name}} non lo vede.",
		"title": "Disattivare l'accesso di {{name}}?"
	},
	"empty": {
		"description": "Invita le persone del tuo team: compariranno qui come «Invitate» finché non completano l'attivazione.",
		"no_matches_description": "Nessuno corrisponde alla ricerca o ai filtri attivi. Prova a togliere un filtro.",
		"no_matches_title": "Nessun risultato",
		"title": "Non c'è ancora nessuno da mostrare"
	},
	"filters": {
		"role": "Ruolo",
		"status": "Stato"
	},
	"invitation": {
		"expired": "Scaduto il {{date}}",
		"expires": "Scade il {{date}}",
		"sent": "Inviato il {{date}}"
	},
	"invite": {
		"action": "Invita",
		"description": "Verrà inviata un'email con il link di invito all'organizzazione.",
		"email": "Email",
		"email_invalid": "Questo non è un indirizzo email valido.",
		"email_placeholder": "nome@esempio.it",
		"email_required": "L'indirizzo email è obbligatorio.",
		"language": "Lingua dell'invito",
		"quota_required": "Serve una quota maggiore di zero.",
		"role": "Ruolo",
		"sent": "Invito inviato a {{email}}.",
		"submit": "Invita utente",
		"title": "Invita nuovo utente"
	},
	"last_activity": {
		"never": "Mai"
	},
	"no_value": "Non disponibile",
	"owner": {
		"locked_helper": "Proprietario dell'organizzazione: si cambia solo dal backoffice",
		"role": "Proprietario"
	},
	"page_title": "Persone",
	"reactivate": {
		"confirm": "Riattiva l'accesso",
		"description": "Potrà accedere di nuovo, con lo stesso ruolo e le stesse condivisioni. Dovrà rifare l'accesso sui suoi dispositivi.",
		"done": "Accesso riattivato.",
		"pending": "Riattivazione…",
		"title": "Riattivare l'accesso di {{name}}?"
	},
	"refusal": {
		"already_invited": "Questo indirizzo ha già un invito in attesa. Usa «Reinvia l'invito» sulla riga di quella persona invece di crearne un secondo.",
		"already_member": "Questo indirizzo fa già parte dell'organizzazione.",
		"closed": "Questo invito è stato sostituito o chiuso. Ricarica la pagina: se la persona ha un invito più recente in attesa, usa quello. Altrimenti invita di nuovo l'indirizzo.",
		"last_administrator": "L'organizzazione deve avere almeno un amministratore.",
		"not_administrator": "Per farlo serve il ruolo di amministratore dell'organizzazione, e in questo momento il tuo non lo è. Ricarica la pagina.",
		"not_queued": "Il messaggio non è stato messo in coda per l'invio: non è stato inviato niente e l'invito precedente è ancora valido. Puoi riprovare subito.",
		"not_queued_database": "L'invito non è stato salvato: non è stato inviato niente e l'invito precedente è ancora valido. Puoi riprovare subito.",
		"not_queued_identity": "Il servizio di accesso non ha risposto: non è stato inviato niente e l'invito precedente è ancora valido. Puoi riprovare subito.",
		"owner_protected": "Questa persona è proprietaria dell'organizzazione e non si può cambiare, disattivare o rimuovere da qui.",
		"person_not_found": "Questa riga non è più valida: la persona non fa più parte dell'elenco, che è stato appena ricaricato.",
		"person_removed": "Questa persona è già stata rimossa dall'organizzazione.",
		"quota_pool_exceeded": "Lo spazio dell'organizzazione non basta per questa assegnazione.",
		"quota_pool_exceeded_at_most": "Lo spazio dell'organizzazione non basta: a questa persona puoi assegnare al massimo {{available}}.",
		"same_address": "L'invito era già stato mandato a questo indirizzo.",
		"throttled_one": "Si può inviare un messaggio al minuto per indirizzo. Riprova fra {{count}} secondo.",
		"throttled_other": "Si può inviare un messaggio al minuto per indirizzo. Riprova fra {{count}} secondi.",
		"throttled_soon": "Si può inviare un messaggio al minuto per indirizzo. Riprova fra poco."
	},
	"remove": {
		"confirm": "Rimuovi dall'organizzazione",
		"description": "Perderà l'accesso e le sessioni aperte verranno chiuse. Le condivisioni restano attive e la sua attività resta nel registro. Per rientrare servirà un nuovo invito.",
		"done": "Persona rimossa dall'organizzazione.",
		"done_sessions_one": "Persona rimossa dall'organizzazione, {{count}} sessione chiusa.",
		"done_sessions_other": "Persona rimossa dall'organizzazione, {{count}} sessioni chiuse.",
		"last_owner_title": "La rimozione lascerebbe qualcosa senza proprietario",
		"pending": "Rimozione…",
		"title": "Rimuovere {{name}} dall'organizzazione?"
	},
	"resend": {
		"already_active": "Non è stato inviato niente: questa persona ha già attivato il suo accesso.",
		"confirm": "Reinvia l'invito",
		"description": "Verrà inviata una nuova email. Il link precedente smetterà di funzionare.",
		"sent": "Invito inviato di nuovo a {{email}}.",
		"title": "Reinviare l'invito a {{email}}?"
	},
	"revoke": {
		"already_active": "Non è stato revocato niente: questa persona ha già attivato il suo accesso, e chiudere l'accesso di chi è già entrato è un'altra azione.",
		"confirm": "Revoca l'invito",
		"description": "Il link di invito smetterà di funzionare. Per entrare servirà un nuovo invito.",
		"done": "Invito revocato.",
		"done_with_grants_one": "Invito revocato. È stato tolto anche l'accesso a {{count}} elemento condiviso in anticipo.",
		"done_with_grants_other": "Invito revocato. È stato tolto anche l'accesso a {{count}} elementi condivisi in anticipo.",
		"last_owner_description_one": "Questa persona è l'unica proprietaria di {{count}} elemento condiviso. Assegnagli un altro proprietario e poi riprova: niente è stato modificato.",
		"last_owner_description_other": "Questa persona è l'unica proprietaria di {{count}} elementi condivisi. Assegna a ciascuno un altro proprietario e poi riprova: niente è stato modificato.",
		"last_owner_title": "La revoca lascerebbe qualcosa senza proprietario",
		"pending": "Revoca…",
		"title": "Revocare l'invito di {{email}}?"
	},
	"role": {
		"member": "Membro",
		"org_admin": "Amministratore"
	},
	"role_description": {
		"member": "Carica, organizza e condivide i propri file.",
		"org_admin": "Gestisce l'organizzazione: persone, sessioni, link condivisi e impostazioni. Usa anche il Drive."
	},
	"search_placeholder": "Cerca per nome o email",
	"set_quota": {
		"amount": "Quota",
		"available": "Disponibili da assegnare: {{available}}",
		"back": "Indietro",
		"choice": "Quota",
		"confirm": "Riduci la quota",
		"confirm_description": "Usa già {{used}}. Con una quota di {{quota}} non potrà caricare file finché non ne elimina abbastanza.",
		"confirm_title": "Ridurre la quota di {{name}}?",
		"description": "In uso: {{used}}, cestino compreso.",
		"done": "La quota di {{name}} ora è {{quota}}.",
		"done_unlimited": "La quota di {{name}} ora non ha limite.",
		"pending": "Salvataggio…",
		"save": "Salva",
		"title": "Quota di {{name}}",
		"too_large": "Puoi assegnare al massimo {{max}}."
	},
	"status": {
		"active": "Attivo",
		"deactivated": "Disattivato",
		"invited": "Invitato",
		"removed": "Rimosso"
	},
	"storage": {
		"full": "piena",
		"near": "quasi piena",
		"no_limit": "Nessun limite",
		"pool_over": "Le persone hanno più spazio assegnato di quello dell'organizzazione: puoi solo ridurre le assegnazioni.",
		"used_of": "{{used}} di {{quota}}",
		"used_unlimited": "{{used}} · nessun limite"
	},
	"storage_pool": {
		"assigned": "Assegnato alle persone",
		"bar": "{{used}} in uso, {{reserved}} assegnati e non ancora usati, {{free}} da assegnare, su {{quota}}",
		"button_label": "Spazio:",
		"free": "Da assegnare",
		"full": "Lo spazio dell'organizzazione è esaurito: nessuno può caricare file finché non se ne libera.",
		"limit": "Quota",
		"near": "Restano {{free}} prima che lo spazio dell'organizzazione finisca.",
		"quota": "Quota dell'organizzazione",
		"reserved": "Assegnato, non ancora usato",
		"unavailable": "Non è stato possibile leggere lo spazio dell'organizzazione.",
		"used": "In uso"
	},
	"total_one": "{{count}} persona",
	"total_other": "{{count}} persone",
	"window": {
		"hours_one": "un'ora",
		"hours_other": "{{count}} ore",
		"minutes_one": "un minuto",
		"minutes_other": "{{count}} minuti",
		"seconds_one": "un secondo",
		"seconds_other": "{{count}} secondi"
	}
}
